interface ProcessStepProps {
  stepNumber: number;
  title: string;
  description: string;
  isCompleted: boolean;
  isActive: boolean;
}

export default function ProcessStep({ stepNumber, title, description, isCompleted, isActive }: ProcessStepProps) {
  return (
    <div className={`relative flex items-start space-x-4 p-6 rounded-xl transition-all duration-300 ${
      isActive ? 'bg-primary/10 border-2 border-primary shadow-soft' : 'bg-card border border-border'
    }`}>
      <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center font-headline font-semibold text-lg transition-all duration-300 ${
        isCompleted ? 'bg-success text-white' : isActive ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
      }`}>
        {isCompleted ? '✓' : stepNumber}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className={`font-headline font-semibold text-xl mb-2 transition-colors duration-300 ${
          isActive ? 'text-primary' : 'text-foreground'
        }`}>
          {title}
        </h3>
        <p className="text-muted-foreground font-body leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}